export default {
  update(el) {
    setTimeout(() => {
      changeHeight(el);
    }, 120);
  },
  inserted(el) {
    changeHeight(el);
  },
};

let changeHeight = function (el) {
  if (el.children !== undefined) {
    for (let i = 0, len = el.children.length; i < len; i++) {
      if (el.children[i].nodeName == 'UL') {
        let curHeight = 0;
        for (let j = 0; j < el.children[i].children.length; j++) {
          curHeight += el.children[i].children[j].offsetHeight + 10;
        }
        let totelHeight = window.innerHeight * 0.8;
        let minHeight = window.innerHeight * 0.3;
        // 留空遮罩头部关闭区域高度
        let maxHeight = totelHeight - 92;
        if (curHeight > maxHeight) {
          curHeight = maxHeight;
        }
        if (curHeight <= minHeight) {
          curHeight = minHeight;
        }
        // 异形屏适配(手机导航栏未隐藏)
        el.style.height = curHeight + 80 + 'px';
      }
    }
  }
};
